function hashCode(str) {
    return Math.abs(Math.cos(str.split('').reduce((c, a, i) => a.charCodeAt(0) * (i + 1) + (c + 1) * 1.17310163, 0)));
}

export function getUniqueColor(input) {
    const colors = [
        "#F21B4D", "#5F2B02", "#4E284F", "#0A4870",
        "#936385", "#0A7A52", "#3F7032", "#C53B03",
        "#B42AF1", "#2014B6", "#3B7478", "#311B78",
        "#A5696A", "#BF30DB", "#FF2EAD", "#6D7005",
        "#fc4671", "#3448ba", "#6b8c09", "#b208d1",
        "#ef10b7", "#006858", "#00185e", "#aa2a03",
        "#1b0b82", "#329b09", "#09348e", "#5b09a3",
        "#0e7493", "#3d9601", "#af0516", "#0c7f08",
        "#05447f", "#0da858", "#bc210d", "#d302a9"
    ];

    let hash = hashCode(input?.toString().toLowerCase());
    let rnd = Math.floor(hash * colors.length);

    return colors[rnd];
}